const galleryImages = [
  {
    src: 'https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/f6f6ecc724df73d45b7fa5131c75cbcc.jpeg',
    alt: 'Megalec Electrical Solutions Van',
    category: 'Company',
  },
  {
    src: 'https://i.ibb.co/0yrrxC01/IMG-3593.jpg',
    alt: 'Consumer Unit Upgrade',
    category: 'Consumer Units',
  },
  {
    src: 'https://i.ibb.co/Zp921bjT/IMG-3702.jpg',
    alt: 'Lighting Installation',
    category: 'Lighting',
  },
  {
    src: 'https://i.ibb.co/nNZt09qN/IMG-4098-1.jpg',
    alt: 'Fuse Board Installation',
    category: 'Consumer Units',
  },
  {
    src: 'https://i.ibb.co/TMsvh7wH/IMG-3557-1.jpg',
    alt: 'Professional Wiring Project',
    category: 'Rewiring',
  },
  {
    src: 'https://i.ibb.co/Y47f2vr4/IMG-1150.jpg',
    alt: 'Light Fitting Installation',
    category: 'Lighting',
  },
  {
    src: 'https://i.ibb.co/Gy07Y8J/IMG-2436.jpg',
    alt: 'Electrical Panel',
    category: 'Consumer Units',
  },
  {
    src: 'https://i.ibb.co/7tfCysFw/IMG-4971.jpg',
    alt: 'Lighting Upgrade',
    category: 'Lighting',
  },
];

export default function Gallery() {
  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-4 font-display">
            Our Recent Work
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Take a look at some of our completed electrical projects across Bridgend and South Wales
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="group relative rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 animate-fade-in"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="w-full h-64 overflow-hidden">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="bg-primary text-white text-xs font-bold px-2.5 py-1 rounded-full">
                    {image.category}
                  </span>
                  <p className="text-white text-sm font-semibold mt-2">{image.alt}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
